$(document).ready(function () {

    var items  = $('.address-item'),
        maps   = $('.footer-map-container'),
        parent = $('.footer-content');        
    
    items.mouseenter(function(){
        var elem   = $(this),
            index  = items.index(elem);

        parent.addClass('show-map');
        maps.removeClass('active');
        maps.eq(index).addClass('active');
    })

    items.mouseleave(function(){
        parent.removeClass('show-map');
    })

});